export function getCreatedVibeProjectId(response) {
    return response && response.id ? response.id : null
}

export function buildVibeProjectDetailParams(id, timestamp = Date.now()) {
    return {
        id,
        _t: timestamp,
    }
}
